import { useFranchisorStore } from '@vuejs/stores/FranchisorStore'
import GlobalStore from '@vuejs/stores/GlobalStore'

/**
 * Set franchisor_id on GlobalStore.agency if it exists
 * @param franchisorId - The franchisor ID to set
 */
function setAgencyFranchisorId(franchisorId: number | string) {
	if (GlobalStore.agency) {
		GlobalStore.agency.franchisor_id = parseInt(franchisorId.toString())
	}
}

/**
 * Return franchisor id from url
 *   this is helpful when the franchisorId is
 *   not in the store or access to store is unavailable
 *
 * @example getFranchisorId()
 * @returns {number} franchisor id
 */

export function getFranchisorId() {
	const franchisorStore = useFranchisorStore()
	const search = window.location.search
	const pathname = window.location.pathname
	const pathArray = pathname.split('/')

	if (pathname === '/agencies' && search.includes('franchisor_id=')) {
		const searchParams = new URLSearchParams(search)
		const franchisorId = searchParams.get('franchisor_id')

		if (franchisorId) {
			franchisorStore.franchisorId = parseInt(franchisorId)
			setAgencyFranchisorId(franchisorId)

			return parseInt(franchisorId)
		}
	}

	if (pathArray[1] === 'franchisors') {
		franchisorStore.franchisorId = parseInt(pathArray[2])
		setAgencyFranchisorId(pathArray[2])

		return parseInt(pathArray[2])
	}

	franchisorStore.franchisorId = GlobalStore.agency?.franchisor_id ??
		GlobalStore.currentUser?.agency?.franchisor?.id ??
		window.current_user?.agency?.franchisor_id ?? null

	return franchisorStore.franchisorId
}
